import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = (isOSOnDarkMode, themeOverride = null) => {
  const urlTheme =
    themeOverride ||
    (typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get('theme'));
  if (urlTheme === 'light' || urlTheme === 'dark') {
    const isDark = urlTheme === 'dark';
    if (isDark) {
      document.body.classList.add('dark');
      document.documentElement.style.setProperty('color-scheme', 'dark');
    } else {
      document.body.classList.remove('dark');
      document.documentElement.style.setProperty('color-scheme', 'light');
    }
    return;
  }

  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
